import { ComponentChildren } from 'preact';
import { T } from '@/ui/tokens';
import { BottomTabs } from '@/ui/primitives/BottomTabs';
import { useUnseenNews } from '@/features/news/useUnseenNews';

export function AppShell({
  tab, children,
}: {
  tab?: 'home' | 'services' | 'orders' | 'referrals' | 'news';
  children: ComponentChildren;
}) {
  const { hasNew } = useUnseenNews();
  return (
    <div style={{
      minHeight: '100%', background: T.bg, color: T.text,
      paddingBottom: tab ? 'calc(72px + var(--safe-bottom, 0px))' : undefined,
    }}>
      {children}
      {tab && <BottomTabs active={tab} hasNewNews={hasNew} />}
    </div>
  );
}
